import React from 'react'

const Footer = () => {
  return <footer>Felipe Curcio &copy; All rights reserverd 2021</footer>
}

export default Footer
